module.exports = __webpack_public_path__ + "img/233622e.png";